/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Aetonix, January 01, 2017
* For information or permission request, email info@aetonixsystems.com
*/

import React, {
	Component
} from "react";
import {
	View,
} from "react-native";
import PropTypes from "prop-types";
import memoize from "memoizee";
import xtend from "xtend";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import inputStyle from "./Layout/intputStyle";
import ErrorMessage from "./Layout/ErrorMessage";
import FormInput from "./FormInput";
import Input from "./Input";
import StyledButton from "ae-base/Base/StyledButton";

var KEY_SCHEMA = {
	type: "string",
	description: "form.dynamicobject.key"
};

export default class DynamicObject extends Component {
	constructor(props){
		super(props);

		this.state = {
			values: [],
			hasChanged: false,
		};

		this.makeUpdateKey = memoize(updateKey.bind(this));
		this.makeUpdateValue = memoize(updateValue.bind(this));
		this.makeRemove = memoize(removeItem.bind(this));
		this.addItem = addItem.bind(this);

	}

	render(){
		var context = this.context;
		var props = this.props;
		var schema = props.schema;
		var errors = props.errors || {};
		var onSubmit = props.onSubmit;

		var hasChanged = this.state.hasChanged;
		var defaultValue = props.defaultValue || {};
		var currentValue = this.state.values;

		var makeUpdateKey = this.makeUpdateKey;
		var makeUpdateValue = this.makeUpdateValue;
		var makeRemove = this.makeRemove;

		var localize = this.context.localize;
		var add = localize("form.dynamicobject.add");
		var remove = localize("form.dynamicobject.remove");

		var toRender = hasChanged ? currentValue : transformObject(defaultValue || {});

		var itemSchema = schema.additionalProperties || {};

		var inputs = toRender.map(function(item, index){
			var key = item.key;
			var value = item.value;
			var inputErrors = errors[key];

			var onChange = makeUpdateValue(index);
			var onChangeKey = makeUpdateKey(index);
			var onRemove = makeRemove(index);

			return (
				<View key={index} style={inputStyle.subFormContainer}>
					<Input schema={KEY_SCHEMA} ariaLabel={"Dynamic Object"} onChange={onChangeKey} defaultValue={key} />
					<FormInput
						unsupportedFeatures={props.unsupportedFeatures}
						platform={props.platform}
						schema={itemSchema}
						defaultValue={value}
						onChange={onChange}
						onSubmit={onSubmit}
						errors={inputErrors}
						showCustomAddButton = {this.props.showCustomAddButton}
					/>
					<StyledButton alert icon="trash" title={remove} onPress={onRemove} />
				</View>
			);
		});

		return (
			<InputContainer>
				<InputLabel schema={schema} />
				<ErrorMessage id={context.id_prefix + props.id + "_error"} errors={errors} schema={schema} />
				{inputs}
				<StyledButton title={add} onPress={this.addItem} icon="aeto-add" />
			</InputContainer>
		);
	}

	updateAt(index, update) {
		var newValues;
		var currentValues = this.state.hasChanged ? this.state.values : transformObject(this.props.defaultValue || {});
		if (!update) {
			newValues = currentValues.filter(function (item, itemIndex) {
				return itemIndex !== index;
			});
		} else if (currentValues[index]) {
			newValues = currentValues.map(function (item, itemIndex) {
				if (itemIndex !== index) return item;
				return xtend(item, update);
			});
		}

		this.setState({
			hasChanged: true,
			values: newValues
		});

		var onChange = this.props.onChange;
		if(onChange)
			onChange(buildObject(newValues));
	}
}

import types from "./Layout/inputTypes";

DynamicObject.propTypes = types;

DynamicObject.contextTypes = {
	id_prefix: PropTypes.string,
	localize: PropTypes.func
};

function updateKey(index) {
	return function(keyName){
		this.updateAt(index, {
			key: keyName
		});
	}.bind(this);
}

function updateValue(index) {
	return function(keyValue) {
		this.updateAt(index, {
			value: keyValue
		});
	}.bind(this);
}

function removeItem(index) {
	return function(){
		this.updateAt(index, null);
	}.bind(this);
}

function addItem(){
	var props = this.props;
	var schema = props.schema;
	var itemSchema = schema.additionalProperties || {};

	var defaultValue = null;
	if(itemSchema.default)
		defaultValue = itemSchema.default;
	else if (itemSchema.type === "object")
		defaultValue = {};
	else if(itemSchema.type === "number")
		defaultValue = 0;
	else if(itemSchema.type === "string")
		defaultValue = "";

	var currentValues = this.state.hasChanged ? this.state.values : transformObject(this.props.defaultValue || {});
	var newValues = currentValues.concat({
		key: "",
		value: defaultValue
	});

	this.setState({
		values: newValues,
		hasChanged: true,
	});

	var onChange = this.props.onChange;
	if (onChange)
		onChange(buildObject(newValues));
}

function transformObject(object){
	return Object.keys(object).map(function(key){
		return {
			key: key,
			value: object[key]
		};
	});
}

function buildObject(values) {
	return values.reduce(function(result, item){
		result[item.key] = item.value;
		return result;
	}, {});
}